import React, { Component } from 'react';
import './UnderConstruction.css';
import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';
import { Link } from 'react-router-dom';


class UnderConstruction extends Component {
  render() {
  return (
    <div class='UnderConstructionMain'>
      This page is Under Construction. <br></br>
      <Link to="/"><input type="submit" value="Go Home"/></Link>
    </div>
  )
};
}

export default UnderConstruction;
